import * as Tabs from '@radix-ui/react-tabs';
import { ReactNode } from 'react';
import Button from '../../button/v2/button';
import { HStack } from '../../layouts/stack.layout';
import Text from '../../typography/v2/text';

export const TAB_STYLE = {
  option:
    'w-fit h-[2rem] border border-off-white px-5 rounded-full flex items-center justify-center whitespace-nowrap',
  'active-option':
    'w-fit h-[2rem] px-5 bg-off-white rounded-full flex items-center justify-center active whitespace-nowrap',
};

type TabTriggerProps = {
  title: string;
  active: boolean;
};

type TabContentProps = {
  children: ReactNode;
  value: string;
};

type TabsOptionsListProps = {
  tabOptions: { [key: string]: string };
  currentValue: string;
  closeFunction: Function;
  showClose: boolean;
};

export type TabOptionMap = {
  content: [];
  value: string;
};

export type TabProps = {
  set: Function;
  current: string;
  tabOptions: { [key: string]: string };
  tabContent: { [key: string]: Function };
  tabControlClassName?: string;
  withoutCloseEffect?: boolean;
};

export function TabTrigger(props: TabTriggerProps) {
  return (
    <Tabs.Trigger
      key={`trigger-${props.title}`}
      value={props.title}
      className={props.active ? TAB_STYLE['active-option'] : TAB_STYLE.option}
    >
      <Text
        key={`text-${props.title}`}
        align="center"
        variant="tab"
        color={props.active ? 'base-200' : 'primary'}
      >
        {props.title}
      </Text>
    </Tabs.Trigger>
  );
}

export function TabOptionsList(props: TabsOptionsListProps) {
  return (
    <HStack extensions="items-center h-fit overflow-auto" gap="sm">
      {props.showClose && (
        <Button
          asIcon="close"
          withButtonStyle
          size="md"
          onClick={props.closeFunction}
        />
      )}
      <HStack
        extensions={
          props.showClose
            ? 'tab-list items-center h-fit tab-list focus'
            : 'tab-list items-center h-fit tab-list'
        }
        gap="sm"
      >
        {Object.keys(props.tabOptions).map((key) => (
          <TabTrigger
            key={key}
            active={props.currentValue === props.tabOptions[key]}
            title={props.tabOptions[key]}
          />
        ))}
      </HStack>
    </HStack>
  );
}

export function TabContent(props: TabContentProps) {
  return (
    <Tabs.Content className="focus:outline-none" value={props.value}>
      {props.children}
    </Tabs.Content>
  );
}
